export default "__VITE_ASSET__CQi5fGcj__"